import React from 'react';
import { TextFieldElement } from 'react-hook-form-mui';
import type { CmsEditableHiddenFieldData } from '@/services/cms/userDefinedForm/CmsEditableHiddenFieldData';

export type EditableHiddenFieldProps = CmsEditableHiddenFieldData;

export function EditableHiddenField(props: EditableHiddenFieldProps) {
    return <TextFieldElement variant={'standard'} name={props.name} slotProps={{ htmlInput: { type: 'hidden' } }} sx={{ display: 'none' }} />;
}
